import { Link } from 'react-router-dom';
import { BookHeart } from 'lucide-react';
import { useLanguage } from '@/i18n/LanguageContext';
import { useAnalytics } from '@/hooks/useAnalytics';
import { lc } from '@/i18n/copy';

const copy = {
  en: {
    text: 'Living Announcements help you speak outward. TRESLOG is your private lifetime space to look inward.',
    link: 'Learn about TRESLOG',
  },
  es: {
    text: 'Los Anuncios Vivientes te ayudan a hablar hacia afuera. TRESLOG es tu espacio privado de por vida para mirar hacia adentro.',
    link: 'Aprende sobre TRESLOG',
  },
  fr: {
    text: 'Les Annonces Vivantes vous aident à vous exprimer. TRESLOG est votre espace privé pour regarder en vous-même.',
    link: 'Découvrir TRESLOG',
  },
  pt: {
    text: 'Os Anúncios Vivos ajudam você a se expressar. TRESLOG é seu espaço privado vitalício para olhar para dentro.',
    link: 'Saiba mais sobre TRESLOG',
  },
  ar: {
    text: 'الإعلانات الحية تساعدك على التعبير للخارج. TRESLOG هو مساحتك الخاصة مدى الحياة للتأمل الداخلي.',
    link: 'تعرف على TRESLOG',
  },
  ja: {
    text: 'リビングアナウンスメントは外に向けて語りかけます。TRESLOGは内面を見つめるためのプライベートな生涯空間です。',
    link: 'TRESLOGについて',
  },
  ko: {
    text: '리빙 어나운스먼트는 바깥을 향해 말하도록 도와줍니다. TRESLOG는 내면을 들여다보는 평생 프라이빗 공간입니다.',
    link: 'TRESLOG 알아보기',
  },
  id: {
    text: 'Living Announcement membantu Anda berbicara ke luar. TRESLOG adalah ruang pribadi seumur hidup untuk melihat ke dalam.',
    link: 'Pelajari tentang TRESLOG',
  },

  hi: {
    text: 'Living Announcements आपको बाहर की ओर बोलने में मदद करते हैं। TRESLOG आपकी निजी आजीवन जगह है जो अंदर की ओर देखने के लिए है।',
    link: 'TRESLOG के बारे में जानें',
  },
};

interface TreslogInlineHintProps {
  className?: string;
}

export function TreslogInlineHint({ className }: TreslogInlineHintProps) {
  const { language } = useLanguage();
  const t = lc(copy, language);
  const { trackTreslogViewed, trackLegacyPlanViewed } = useAnalytics();

  const handleClick = () => {
    trackTreslogViewed('dashboard');
    trackLegacyPlanViewed('history_inline_hint');
  };

  return (
    <div
      className={`flex flex-col sm:flex-row items-center gap-2 text-center sm:text-left py-4 px-6 rounded-xl bg-muted/50 border border-border ${className}`}
    >
      <BookHeart className="h-4 w-4 text-amber-500 flex-shrink-0" />
      <p className="text-sm text-muted-foreground">{t.text}</p>
      <Link
        to="/treslog"
        onClick={handleClick}
        className="text-sm font-medium text-primary hover:underline whitespace-nowrap"
      >
        {t.link}
      </Link>
    </div>
  );
}
